import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isLoggedIn } from "../../service/auth.service";

const PrivateOutlet = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.userToken);

  useEffect(() => {
    if (!isLoggedIn() || !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [navigate, isAuthenticated]);

  return <Outlet />;
};

export default PrivateOutlet;